import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { API, useAuth } from './AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');

    (async () => {
      if (!sessionId) {
        navigate('/login', { replace: true });
        return;
      }
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { 'X-Session-ID': sessionId }, withCredentials: true }
        );
        try { if (data.token) localStorage.setItem('bp_token', data.token); } catch {}
        setUser(data.user);
        window.history.replaceState({}, '', '/');
        navigate('/', { replace: true, state: { user: data.user } });
      } catch (err) {
        const msg = err?.response?.data?.detail || 'Falha ao autenticar com Google';
        navigate('/login', { replace: true, state: { error: msg } });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex items-center gap-3 text-slate-600">
        <Loader2 className="w-5 h-5 animate-spin text-emerald-600" />
        <span className="text-sm font-semibold">Finalizando login...</span>
      </div>
    </div>
  );
}
